<!--
 * @Description:自助签到成功
 * @Author: 山淑兰
 * @Date: 2019-11-26 14:10:55
 * @LastEditTime: 2019-11-27 17:39:02
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="selfSigninSucceeded">
    <div class="loading" v-if="loading">
      <van-loading type="spinner" color="#3b82f6" vertical size="30px" text-size="16px">加载中...</van-loading>
    </div>
    <div v-else>
      <div class="SigninSucceeded_container">
        <div class="signinStatus">
          <div class="signinStatus_icon">
            <van-icon name="checked" size="90px" color="#67C23A" />
          </div>
          <div>
            <p>恭喜您，签到成功</p>
            <p class="signinStatus_subheading">欢迎莅临现场</p>
          </div>
        </div>
        <div class="SigninSucceeded_content">
          <div class="SigninSucceeded_Info">
            <ul>
              <li v-for="(item,index) in infoData" :key="index">
                <span>{{item.name}}</span>
                <span>{{item.val}}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "selfSigninSucceeded",
  data() {
    return {
      loading: false,
      infoData: [
        {
          name: '姓名',
          val: '朱一龙'
        },
        {
          name: '身份',
          val: '主持人'
        }, {
          name: '手机',
          val: '18079311918'
        }, {
          name: '公司',
          val: '微奇互动'
        },
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
#selfSigninSucceeded {
  .SigninSucceeded_container {
    .signinStatus {
      margin: 16px 0px 30px;
      text-align: center;
      font-size: 34px;

      .signinStatus_subheading {
        color: #64748b;
        font-size: 32px;
      }
    }
    .SigninSucceeded_content {
      .SigninSucceeded_Info {
        width:94%;
        margin:0 auto;
        border-radius: 10px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.04);
        font-size: 28px;
        >ul{
          padding:20px 0;
          >li{
            height:50px ;
            line-height: 50px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            >span{
              &:nth-child(1){
                flex:1;
                text-align: right;
                margin-right: 6%;
              }
              &:nth-child(2){
                flex:2;
              }
            }
          }
        }
      }
    }
  }
}
</style>